// extracted by mini-css-extract-plugin
export var banner = "_id-0";
export var closeButton = "_id-2";
export var greenCheckmark = "_id-3";
export var hereLink = "_id-4";
export var titleIcon = "_id-1";